import { Button, Icon, IconIdentifier } from '@aus-platform/design-system';
import { useAppDispatch } from 'app/hooks';
import { setActiveSidebarOption } from 'map-3d/shared/map-3d-slices';
import { map3dSidebarItems } from '../../constants';
import { Map3DSidebarOption } from '../../shared';

export const GenerateDEMEmptyState: React.FC = () => {
  // Dispatch.
  const dispatch = useAppDispatch();

  // Handlers.
  const handleOpenWorkspace = () => {
    const workspaceItem =
      map3dSidebarItems.find(
        (item) => item.cardProps.title === Map3DSidebarOption.Workspace,
      ) ?? map3dSidebarItems[0];

    dispatch(setActiveSidebarOption(workspaceItem));
  };

  return (
    <div className="generate-dem__empty-state">
      {/* TODO: Update icon */}
      <Icon identifier={IconIdentifier.Terrain} size={78} />

      <div className="generate-dem__empty-state__title">
        No point cloud layer in workspace
      </div>

      <div className="generate-dem__empty-state__description">
        To generate a DEM, please load a point cloud layer into your workspace.
      </div>

      <div className="generate-dem__empty-state__button-container">
        <Button onClick={handleOpenWorkspace}>Open Workspace</Button>
      </div>
    </div>
  );
};
